import {
  GatsbyAnimation,
  IGatsbyAnimation,
  IGatsbyExtractedAnimation,
} from "@bond-london/gatsby-transformer-extracted-lottie";
import {
  GatsbySvg,
  IGatsbyExtractedSvg,
  IGatsbySvg,
} from "@bond-london/gatsby-transformer-extracted-svg";
import {
  GatsbyImage,
  GatsbyImageProps,
  IGatsbyImageData,
} from "gatsby-plugin-image";
import React from "react";

export interface IVideo {
  mimeType: string;
  localFile: {
    publicURL: string;
  };
}
export type IVisual =
  | IGatsbyImageData
  | IGatsbySvg
  | IGatsbyExtractedAnimation
  | IVideo;

function isImage(o: unknown): o is IGatsbyImageData {
  return !!(o as IGatsbyImageData)?.images;
}

function isSvg(o: unknown): o is IGatsbyExtractedSvg {
  const possible = o as IGatsbySvg;
  return !!possible?.encoded || !!possible?.encodedUrl;
}

function isAnimation(o: unknown): o is IGatsbyExtractedAnimation {
  const possible = o as IGatsbyAnimation;
  return !!possible?.animationUrl;
}

function isVideo(o: unknown): o is IVideo {
  const possible = o as IVideo;
  return (
    possible?.mimeType?.startsWith("video/") && !!possible?.localFile?.publicURL
  );
}

export const Visual: React.FC<
  { visual: IVisual } & Partial<GatsbyImageProps> &
    React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    > &
    React.DetailedHTMLProps<
      React.VideoHTMLAttributes<HTMLVideoElement>,
      HTMLVideoElement
    >
> = (props) => {
  const { visual, alt, loading, ...rest } = props;
  if (isImage(visual)) {
    return (
      <GatsbyImage
        image={visual}
        alt={alt ?? ""}
        loading={loading ?? "lazy"}
        {...rest}
      />
    );
  }

  if (isSvg(visual)) {
    return <GatsbySvg svg={visual} alt={alt} {...rest} />;
  }

  if (isAnimation(visual)) {
    return <GatsbyAnimation animation={visual} {...rest} />;
  }

  if (isVideo(visual)) {
    // eslint-disable-next-line jsx-a11y/media-has-caption
    return <video src={visual.localFile.publicURL} {...rest} />;
  }

  return null;
};
